type SuzukiProps = {
  className?: string;
};

export default function Suzuki({ className }: SuzukiProps) {
  return (
    <svg
      width="164"
      height="32"
      viewBox="0 0 164 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Suzuki</title>
      <g clipPath="url(#clip0_18794_229804)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M163.451 7.00366V26.0505H156.575V7.00366H163.451ZM107.456 7.00366H85.8781V11.9938H95.9478L85.8781 21.9041V26.0505H107.456V21.0604H97.3503L107.456 11.1501V7.00366ZM138.856 7.00366H132.015V26.0505H138.892V19.7954L145.77 26.0505H154.997L145.277 16.0703L154.997 7.00366H145.77L138.856 13.4005V7.00366ZM48.7225 26.6136C41.5656 26.5777 38.9338 24.1892 38.933 19.9032H48.0198C48.0198 21.2381 50.0213 21.8011 51.1786 21.8351C52.3708 21.871 53.2131 21.4138 53.2131 20.5701C53.2131 19.2786 52.0859 19.1926 48.9568 18.954C48.4236 18.9133 47.8323 18.8682 47.1785 18.8119C38.8981 18.6013 38.8981 15.0169 38.8981 11.9947C38.8981 8.90165 43.1086 6.40757 48.7923 6.40757H51.4936C57.7037 6.40757 60.9313 9.07834 60.9313 12.9083H53.2131C53.2131 12.0646 50.8268 10.8705 49.6346 10.8705C48.4424 10.8705 47.4945 11.187 47.4596 12.1006C47.5185 13.184 49.3294 13.3651 52.273 13.6595C52.7662 13.7089 53.2912 13.7614 53.8451 13.8218C57.7046 14.2432 61.634 15.7189 61.634 19.7954C61.5991 24.8923 58.4413 26.6136 52.6519 26.6136H48.7225ZM84.4388 19.7964C84.4737 22.9584 82.9306 26.6145 74.6153 26.6145L72.3327 26.6136C63.5978 26.6136 62.896 22.7836 62.896 19.7954V7.00366H69.7729V18.778C69.7729 18.8026 69.7726 18.8297 69.7722 18.859C69.7631 19.5398 69.7382 21.4138 73.8428 21.4138C77.6471 21.4138 77.5888 19.6622 77.565 18.9459C77.5634 18.8959 77.5619 18.8509 77.5619 18.8119V7.00366H84.4388V19.7964ZM130.402 19.7964C130.436 22.9584 128.893 26.6145 120.577 26.6145L118.297 26.6136C109.561 26.6136 108.858 22.7836 108.858 19.7954V7.00366H115.736V18.778C115.736 18.8027 115.736 18.8299 115.735 18.8593C115.726 19.5404 115.701 21.4138 119.806 21.4138C123.61 21.4138 123.551 19.6627 123.527 18.9462C123.526 18.8961 123.524 18.851 123.524 18.8119V7.00366H130.402V19.7964Z"
          fill="#121212"
        />
        <path
          d="M16.1622 31.7454C19.1795 29.0038 28.5125 23.3817 31.7401 22.3273L12.3733 8.40943L13.2505 7.84732L20.3736 13.0481C21.2508 13.6801 28.6181 15.1567 31.6005 10.9394L16.0216 0.257324C13.2854 2.85819 3.67131 8.69195 0.0230103 9.95598L20.3726 24.0127L19.8114 24.7525L12.2328 19.5517C9.84743 18.111 3.60152 16.5994 0.163553 21.2031L16.1622 31.7454Z"
          fill="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_18794_229804">
          <rect width="164" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
